import React from 'react';
import PropTypes from 'prop-types';
import RichTextRenderer from 'components/RichTextRenderer';
import { StyledCostCoverage, SWCovers, YouCover } from './styled';

const CostCoverage = ({ safetyWingCovers, youCover }) => {
  return (
    <StyledCostCoverage>
      {safetyWingCovers && (
        <SWCovers>
          <div>SafetyWing covers</div>
          <b>
            <RichTextRenderer richText={safetyWingCovers} />
          </b>
        </SWCovers>
      )}
      {youCover && (
        <YouCover>
          <div>You cover</div>
          <b>
            <RichTextRenderer richText={youCover} />
          </b>
        </YouCover>
      )}
    </StyledCostCoverage>
  );
};

CostCoverage.propTypes = {
  safetyWingCovers: PropTypes.object,
  youCover: PropTypes.object
};

export default CostCoverage;
